export const BASE = process.env.NODE_ENV == "production" ? "https://workshop-api.petraconcrete.net" : "http://172.16.1.25:8000";

export function getToken() {
    return localStorage.getItem("api_token");
}

export function getHeaders() {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`
    }
}